import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "./authClient";
import { SKIP_AUTH, getDevAuthUser } from "./authMode";

const PrivateRoute = ({ children }) => {
    const [status, setStatus] = useState("checking"); // checking | authenticated | unauthenticated

    useEffect(() => {
        let isMounted = true;

        const checkSession = async () => {
            if (SKIP_AUTH) {
                const data = getDevAuthUser();
                localStorage.setItem("email", data.email);
                localStorage.setItem("username", data.username);
                localStorage.setItem("role", data.role);
                if (isMounted) {
                    setStatus("authenticated");
                }
                return;
            }

            const data = await getCurrentUser();
            if (!isMounted) return;

            if (data?.email) {
                localStorage.setItem("email", data.email);
                if (data.username) {
                    localStorage.setItem("username", data.username);
                }
                setStatus("authenticated");
            } else {
                localStorage.removeItem("email");
                localStorage.removeItem("username");
                setStatus("unauthenticated");
            }
        };

        checkSession();

        return () => {
            isMounted = false;
        };
    }, []);

    if (status === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="rounded-2xl border border-slate-200 bg-white px-6 py-4 shadow-sm">
                    <p className="text-sm text-slate-600">Checking session...</p>
                </div>
            </div>
        );
    }

    if (status === "unauthenticated") {
        return <Navigate to="/signin" replace />;
    }

    return children;
};

export default PrivateRoute;
